import React, { useState } from "react";
import HomeCard from "../components/HomeCard";
import "./TilboApps.css";

import { appsList } from "../data/appsData";

export default function TilboApps() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleMail = () => {
    const mailto = `mailto:tilboapps@gmail.com?subject=${encodeURIComponent(
      subject,
    )}&body=${encodeURIComponent(message)}`;
    window.location.href = mailto;
  };

  return (
    <div className="tilboapps-container">
      {/* Header */}
      <header className="tilboapps-header">
        <h1 className="tilboapps-title">Tilbo Apps</h1>
        <p className="tilboapps-subtitle">By Brent Van Tilborg</p>

        <div className="tilboapps-avatar-container">
          <img
            src={require("../assets/profile.jpg")}
            alt="Profile Avatar"
            className="tilboapps-avatar"
          />
        </div>
      </header>

      {/* App Cards */}
      <div className="tilboapps-grid">
        {appsList.map((app, index) => {
          return <HomeCard app={app} index={index} key={index} />;
        })}
      </div>

      {/* Contact Section */}
      <section className="tilboapps-contact">
        <h2 className="tilboapps-contact-title">Contact Me</h2>
        <p className="tilboapps-contact-text">
          Have feedback, feature ideas, or just want to say hi? You can reach me
          directly at{" "}
          <a
            href="mailto:tilboapps@gmail.com"
            className="tilboapps-link"
          >
            tilboapps@gmail.com
          </a>
          , or use the form below:
        </p>

        <div className="tilboapps-form">
          <input
            type="text"
            placeholder="Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="tilboapps-input"
          />
          <textarea
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={5}
            className="tilboapps-input"
          />
          <button
            onClick={handleMail}
            className="tilboapps-button"
          >
            Open Mail App
          </button>
        </div>
      </section>

      {/* X Profile */}
      <div className="tilboapps-social">
        <a
          href={"https://x.com/BrentVanTilborg"}
          target="_blank"
          rel="noopener noreferrer"
          className="tilboapps-social-btn"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 1227"
            fill="white"
            className="tilboapps-social-icon"
          >
            <path d="M714.163 519.284L1160.89 0H1056.54L667.137 450.887L357.328 0H0L464.409 681.821L0 1226.37H104.355L514.264 748.682L842.672 1226.37H1200L714.137 519.284H714.163ZM568.291 686.084L520.562 616.618L142.016 79.6944H306.615L611.412 517.867L659.141 587.333L1056.6 1150.3H891.999L568.291 686.084Z" />
          </svg>
          <span className="tilboapps-social-text">Follow on X</span>
        </a>
      </div>

      {/* Footer */}
      <footer className="tilboapps-footer">
        © {new Date().getFullYear()} TilboApps. All rights reserved.
      </footer>
    </div>
  );
}
